(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-order-form"] && !Shopify.designMode) return;
  try {
    
    function validateForm(){
  return true;
  }

  const selectModel = document.getElementById("ContactForm-Model")
  selectModel.addEventListener("change", function() {



  var selectElement = document.getElementById("ContactForm-FrameSize");
  selectElement.options.length = 0;
  // Create a new option element
  var newOption = new Option("Please Select", "Please Select");
  // Add the option to the select element
  selectElement.add(newOption);
    var newOption = new Option("Custom (see Notes)", "Custom(see Notes)");
  // Add the option to the select element
  selectElement.add(newOption);


  if (selectModel.value=="Voltage" || selectModel.value=="Voltage AR"){

  // Create a new option element
  newOption = new Option("48", 48);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("50", 50);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("52", 52);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("54", 54);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("56", 56);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("58", 58);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("60", 60);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("62", 62);
  // Add the option to the select element
  selectElement.add(newOption);

  }

  if (selectModel.value=="Joule"){

  // Create a new option element
  var newOption = new Option("50", 50);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("52", 52);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("54", 54);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("56", 56);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("58", 58);
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("60", 60);
  // Add the option to the select element
  selectElement.add(newOption);
  }

  if (selectModel.value=="Megawatt"){

  // Create a new option element
  var newOption = new Option("Small", "Small");
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("Medium", "Medium");
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("Medium Large", "Medium Large");
  // Add the option to the select element
  selectElement.add(newOption);

  newOption = new Option("Extra Large", "Extra Large");
  // Add the option to the select element
  selectElement.add(newOption);

  }

   return true;
   });


   function customFinish() {
  var selectFinish = document.getElementById("ddlFinishOptions");

  var divFO = document.getElementById("divLogoColors");


  if (selectFinish.value=="Blasted Anodized Logo" || selectFinish.value=="Custom Paint"){

  divFO.style.display = "block";
  } else {
  divFO.style.display = "none";
  }
  return true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
